<template>
	<div class="text-white text-xs">
		<div class="bg-grey-12 rounded-md p-5 mb-2">
			<div
				class="flex justify-between items-center cursor-hover-pointer mb-4"
				@click="expand()"
			>
				<div class="font-semibold">
					Estimated Order Details
					<TooltipRincianOrder :direction="direction" />
				</div>
				<div class="">
					<IconArrow :direction_prop="arrowDirection" />
				</div>
			</div>

			<div :class="`${isExpanded ? 'block' : 'hidden'}`">
				<div class="flex items-center mb-2">
					<div class="grow">Contract Value</div>
					<div>
						{{ currencySymbol }}
						{{ valueShown }}
					</div>
				</div>

				<div class="flex items-center mb-2">
					<div class="grow">Fee</div>
					<div>
						{{ minusSign }}
						{{ currencySymbol }}
						{{ feeShown }}
					</div>
				</div>

				<div class="flex items-center mb-2">
					<div class="grow">Tax</div>
					<div>
						{{ minusSign }}
						{{ currencySymbol }}
						{{ taxShown }}
					</div>
				</div>

				<div
					v-if="$store.getters.paymentMethod == 'gopay'"
					class="flex items-center mb-2"
				>
					<div class="grow">FX Buffer</div>
					<div>
						{{ minusSign }}
						{{ currencySymbol }}
						{{ fxBufferShown }}
					</div>
				</div>

				<div
					v-if="$store.getters.paymentMethod == 'gopay'"
					class="flex items-center mb-2"
				>
					<div class="grow">Admin Fee</div>
					<div>
						{{ currencySymbol }}
						{{ adminFeeShown }}
					</div>
				</div>
			</div>

			<div
				class="items-center"
				:class="`${
					direction == 'sell'
						? isExpanded
							? 'flex'
							: 'hidden'
						: `flex text-sm font-semibold text-gold`
				}`"
			>
				<div class="grow">
					Total {{ direction == "buy" ? "Buy" : "Sell" }} Order
				</div>
				<div>
					{{ currencySymbol }}
					{{ totalDirOrderShown }}
				</div>
			</div>

			<div v-if="direction == 'sell'" class="mt-4">
				<div
					class="items-center mb-2"
					:class="`${isExpanded ? 'flex' : 'hidden'}`"
				>
					<div class="grow">Storage Fee</div>
					<div>
						<!-- {{ minusSign }} -->
						{{ currencySymbol }}
						{{ storageFeeShown }}
					</div>
				</div>

				<div class="flex justify-between text-gold">
					<div>
						{{
							direction == "buy"
								? "Total Est. Maximum Payment"
								: "Est. Amount Received"
						}}
						<TooltipEstimateMaximumPayment v-if="direction == 'buy'" />
					</div>
					<div>
						{{ currencySymbol }}
						{{ finalAmountShown }}
					</div>
				</div>
			</div>
		</div>

		<div
			v-if="direction == 'buy'"
			class="bg-grey-12 rounded-md p-5"
			:class="`${isExpanded ? 'block' : 'hidden'}`"
		>
			<div
				v-if="$store.getters.paymentMethod == 'rped'"
				class="flex items-center mb-2"
			>
				<div class="grow">FX Buffer</div>
				<div>
					{{ minusSign }}
					{{ currencySymbol }}
					{{ fxBufferShown }}
				</div>
			</div>

			<div class="flex justify-between">
				<div>
					{{
						direction == "buy"
							? "Total Est. Maximum Payment"
							: "Est. Amount Received"
					}}
					<TooltipEstimateMaximumPayment v-if="direction == 'buy'" />
				</div>
				<div>
					{{ currencySymbol }}
					{{ finalAmountShown }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import utils from "../../utils"

	import IconArrow from "../icons/IconArrow.vue"
	import TooltipEstimateMaximumPayment from "./TooltipEstimateMaximumPayment.vue"
	import TooltipRincianOrder from "./TooltipRincianOrder.vue"

	export default {
		name: "OrderDetails_TradeTicket",

		components: {
			IconArrow,
			TooltipRincianOrder,
			TooltipEstimateMaximumPayment,
		},

		props: {
			orderDetails: Object,
			direction: String,
		},

		data() {
			return {
				isExpanded: false,
			}
		},

		computed: {
			arrowDirection() {
				if (this.isExpanded) {
					return "up"
				} else {
					return "down"
				}
			},

			minusSign() {
				const contractValue = this.orderDetails.contractValue
				if (this.direction == "buy" || contractValue == 0) {
					return ""
				} else {
					return "-"
				}
			},

			valueShown() {
				return utils.currencyFormat(this.orderDetails.contractValue)
			},

			feeShown() {
				return utils.currencyFormat(this.orderDetails.fee)
			},

			taxShown() {
				return utils.currencyFormat(this.orderDetails.tax)
			},

			totalDirOrderShown() {
				if (this.$store.getters.paymentMethod == "rped") {
					return utils.currencyFormat(this.orderDetails.totalTypeA)
				} else {
					return utils.currencyFormat(this.orderDetails.total)
				}
			},

			fxBufferShown() {
				return utils.currencyFormat(this.orderDetails.fxBuffer)
			},

			storageFeeShown() {
				return utils.currencyFormat("0.00")
			},

			adminFeeShown() {
				return utils.currencyFormat(this.orderDetails.adminFee)
			},

			finalAmountShown() {
				if (this.$store.getters.paymentMethod == "rped") {
					return utils.currencyFormat(this.orderDetails.finalAmount)
				} else {
					return utils.currencyFormat(this.orderDetails.totalTypeC)
				}
			},
		},

		methods: {
			expand() {
				this.isExpanded = !this.isExpanded
			},
		},
	}
</script>

<style scoped></style>
